import { useTranslation } from "react-i18next";
import { useWatch } from "react-hook-form";
import { GridItem, InquiryKind, isArrayNotEmpty, RadiosFormField } from "@duosoftbg/nacid-components";
import useAppSelector from "../../../../../../../hooks/redux/base/useAppSelector";
import { useEffect } from "react";
import useAppDispatch from "../../../../../../../hooks/redux/base/useAppDispatch";
import { citingSearchKindThunk } from "../../../../../../../store/redux/slice/AppData/citingSearchKind";
import { impactFactorSearchKindThunk } from "../../../../../../../store/redux/slice/AppData/impactFactorSearchKind";

const InquirySearchKindsFormFields = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const inquiryKinds = useWatch({ name: "inquiryKinds" });

  const citingSearchKind = useAppSelector((state) => {
    return state.AppData.CitingSearchKind;
  });

  const impactFactorSearchKind = useAppSelector((state) => {
    return state.AppData.ImpactFactorSearchKind;
  });

  useEffect(() => {
    dispatch(citingSearchKindThunk());
    dispatch(impactFactorSearchKindThunk());
  }, [dispatch]);

  return (
    <>
      <GridItem sm={6} md={6}>
        {isArrayNotEmpty(citingSearchKind?.data) && inquiryKinds?.includes(InquiryKind.CITINGS) && (
          <RadiosFormField
            required={true}
            fieldName={"citingSearchKind.id"}
            labelCode={"l.inquiry.citingsSearchKind"}
            radioOptions={citingSearchKind?.data.map((item) => {
              return {
                value: item.id,
                text: item.name,
              };
            })}
          />
        )}
      </GridItem>
      <GridItem sm={6} md={6}>
        {isArrayNotEmpty(impactFactorSearchKind?.data) &&
          [InquiryKind.IMPACT_FACTOR, InquiryKind.IMPACT_FACTOR_CITINGS].some((k) => inquiryKinds?.includes(k)) && (
            <RadiosFormField
              required={true}
              fieldName={"impactFactorSearchKind.id"}
              labelCode={"l.inquiry.impactSearchKind"}
              radioOptions={impactFactorSearchKind?.data.map((item) => {
                return {
                  value: item.id,
                  text: item.name,
                };
              })}
            />
          )}
      </GridItem>
    </>
  );
};

export default InquirySearchKindsFormFields;
